import React, { Component } from "react";
import AllResultsContainer from "./AllResultsContainer";
import FilteredResultsContainer from "./FilteredResultsContainer";
import School from "./School";
import District from "./District";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: window.scoeWebSite.schoolsDirectory.data,
      apiEndpoint: window.scoeWebSite.schoolsDirectory.apiEndpoint,
      searchString: "",
      loading: true,
      elementsToHide: window.scoeWebSite.schoolsDirectory.elementsToHide || [],
      district: window.scoeWebSite.schoolsDirectory.district || "",
      placeholder: window.scoeWebSite.schoolsDirectory.placeholderText
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    function formatFixes(dat) {
      function fixPhone(rsp) {
        function fp(ph) {
          return ph.replace(
            /(\([2-9][0-9][0-9]\) [2-9][0-9][0-9])(-[0-9][0-9][0-9][0-9])\/(-[0-9][0-9][0-9][0-9])/,
            "$1$2/$1$3"
          );
        }
        return rsp.map(r => {
          const p1 = r["Phone Number Combined"];
          if (p1) r["Phone Number Combined"] = fp(p1);
          const p2 = r["Phone 2 Number Combined"];
          if (p2) r["Phone 2 Number Combined"] = fp(p2);
          return r;
        });
      }
      function addDistDataToSchools(data) {
        const distToYear = data.districts.reduce((a, v) => {
          a[v["DISTRICT ID"]] = {
            dashboard: v["Dashboard"],
            distName: v["District Name"]
          };
          return a;
        }, {});
        data.schools.forEach(s => {
          s.dashboard = distToYear[s["districtId"]].dashboard;
          s.distName = distToYear[s["districtId"]].distName;
        });
        return data;
      }
      function makeDistNameLookup(dists) {}
      makeDistNameLookup(dat.districts);
      fixPhone(dat.districts);
      fixPhone(dat.schools);
      addDistDataToSchools(dat);
      return dat;
    }

    if (!this.state.data) {
      this.setState({ loading: true });
      fetch(this.state.apiEndpoint, {
        headers: {
          Accept: "application/json"
        }
      })
        .then(response => response.json())
        .then(data =>
          this.setState({ loading: false, data: formatFixes(data) })
        );
    } else {
      this.setState({ loading: false, data: formatFixes(this.state.data) });
    }
  }
  handleChange(event) {
    const { checked, type, value: val, name } = event.target;
    const value = type === "checkbox" ? checked : val;
    this.setState({
      [name]: value
    });
  }

  //try putting formatPhForSearch here and see if it works without binding
  //same for the functions that could be assigned to districtsFilter and schoolsFilter

  render() {
    if (this.state.loading) return null;
    const searchString = this.state.searchString.toLowerCase();
    const hideDistricts =
      this.state.loading || this.state.elementsToHide.includes("Districts");
    const hideSchools =
      this.state.loading || this.state.elementsToHide.includes("Schools");

    function formatPhForSearch(ph) {
      return ph ? ph.replace(/[() -]/g, "").replace(/[^0-9][^0-9]*/g, " ") : "";
    }
    const schoolsFilter = searchString
      ? ({
          "School Name Last First": sn,
          distName: dn,
          "Principal Title Name": an,
          CITY: ci,
          "Phone Number Combined": pn,
          "Grade Level": gl
        }) => {
          return (
            `${sn} ${dn} ${an} ${ci} ${gl} ${formatPhForSearch(pn)}`
              .toLowerCase()
              .indexOf(searchString) > -1
          );
        }
      : () => true;

    const districtsFilter = searchString
      ? ({
          "District Name": dn,
          ADMINISTRATOR: an,
          CITY: ci,
          "PHONE NUMBER COMBINED": pn,
          "GRADE LEVEL": gl
        }) => {
          return (
            `${dn} ${an} ${ci} ${gl} ${formatPhForSearch(pn)}`
              .toLowerCase()
              .indexOf(searchString) > -1
          );
        }
      : () => true;

    const districtFilter = this.state.district
      ? ({ distName: dn }) => dn === this.state.district
      : () => true;

    //page was janky, maybe not running empty filters would help.
    let filteredSchools = hideSchools ? [] : this.state.data.schools;
    if (this.state.district) {
      filteredSchools = filteredSchools.filter(districtFilter);
    }
    if (searchString) {
      filteredSchools = filteredSchools.filter(schoolsFilter);
    }

    // const filteredSchools = hideSchools
    //   ? []
    //   : this.state.data.schools.filter(districtFilter).filter(schoolsFilter);

    const filteredDistricts = hideDistricts
      ? []
      : this.state.data.districts
          .filter(districtsFilter)
          .filter(
            d => d["District Name"] !== "Sacramento County Office of Education"
          );

    return (
      <AllResultsContainer
        hideSearch={this.state.elementsToHide.includes("Search")}
        loading={this.state.loading}
        inputHandleOnChange={this.handleChange}
        placeholder={this.state.placeholder}
        ariaLabel={`Search for ${
          this.state.district
            ? `schools in ${this.state.district}`
            : hideSchools
            ? "districts in the county"
            : "schools and districts"
        }`}
      >
        {this.state.loading ? (
          ""
        ) : (
          <div>
            <FilteredResultsContainer
              itemType="District"
              showMe={!hideDistricts && filteredDistricts.length > 0}
              filterString={searchString}
              showHeader={!hideSchools}
              secondColumnName="Enrollment"
            >
              {filteredDistricts.map((d, i) => (
                <District
                  key={d["key"]}
                  districtId={d["DISTRICT ID"]}
                  enrollment={d["ENROLLMENT"]}
                  maddr={
                    d["Mailing Address"] ? d["Mailing Address"] : undefined
                  }
                  paddr={
                    d["PHYSICAL ADDRESS"] ? d["PHYSICAL ADDRESS"] : undefined
                  }
                  city={d["CITY"]}
                  zip={d["ZIP CODE"]}
                  phone={d["PHONE NUMBER COMBINED"]}
                  website={d["DISTRICT URL"]}
                  cdeYear={d["Dashboard"]}
                  name={d["District Name"]}
                  grades={d["GRADE LEVEL"]}
                  cdsCode={d["CDS Code"]}
                  administrator={d["ADMINISTRATOR"]}
                ></District>
              ))}
            </FilteredResultsContainer>

            <FilteredResultsContainer
              itemType="School"
              showMe={!hideSchools && filteredSchools.length > 0}
              filterString={searchString}
              showHeader={!hideDistricts}
              secondColumnName="District"
            >
              {filteredSchools.map((d, i) => (
                <School
                  key={d["key"]}
                  name={d["School Name Last First"]}
                  districtId={d["districtId"]}
                  maddr={
                    d["Mailing Address"] ? d["Mailing Address"] : undefined
                  }
                  paddr={
                    d["Physical Address"] ? d["Physical Address"] : undefined
                  }
                  city={d["CITY"]}
                  zip={d["ZIP Code"]}
                  phone={d["Phone Number Combined"]}
                  website={d["URL"]}
                  grades={d["Grade Level"]}
                  cdsCode={d["CDS Code"]}
                  cdeYear={d.dashboard}
                  administrator={d["Principal Title Name"]}
                  calendarType={d["Calendar Type"]}
                  distName={d.distName}
                ></School>
              ))}
            </FilteredResultsContainer>
          </div>
        )}
      </AllResultsContainer>
    );
  }
}

export default Main;
